module.exports = __webpack_public_path__ + "img/Dra-Jessica-Zermeno-Rodriguez.e3f2982a.jpg";